import BancMesureSection, { HUMIDITE_BANC_CONFIG } from "./BancMesureSection";

export default function HumiditeBancSection(props) {
  return <BancMesureSection config={HUMIDITE_BANC_CONFIG} {...props} />;
}
